import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { bindAll } from '@bibliocommons/utils-react';
import { getValidHtmlAttributes } from '@bibliocommons/utils-html';

import './RadioButton.scss';

export class RadioButton extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleChange() {
    const { handleChange, value } = this.props;
    if (handleChange) handleChange(value);
  }

  renderLabel() {
    const { label, srOnlyLabel } = this.props;

    if (srOnlyLabel) return <ScreenReaderMessage>{label}</ScreenReaderMessage>;
    return <span className="radio-button__label">{label}</span>;
  }

  render() {
    const { className, checked, name, id } = this.props;
    const htmlProps = getValidHtmlAttributes(this.props, 'input');
    const classNames = cn('cp-radio-button', className);

    return (
      <label className={classNames} htmlFor={id}>
        <input
          {...htmlProps}
          id={id}
          type="radio"
          checked={checked}
          className="radio-button__input"
          onChange={this.handleChange}
          name={name}
        />
        <span className="radio-button__button" />
        {this.renderLabel()}
      </label>
    );
  }
}

RadioButton.propTypes = {
  value: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]).isRequired,
  handleChange: PropTypes.func,
  checked: PropTypes.bool.isRequired,
  className: PropTypes.string,
  srOnlyLabel: PropTypes.bool
};

export default RadioButton;
